// extracted by mini-css-extract-plugin
module.exports = {"chartWrapper":"PomBarChart_chartWrapper__2ZFSh"};